export default "__VITE_ASSET__BBUtLTjD__"